module.exports = __webpack_public_path__ + "static/media/studentsIcon.b13b4cfe.png";